/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlCompleteRecoveryCodeResponse
 */
export interface ControlCompleteRecoveryCodeResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlCompleteRecoveryCodeResponse
     */
    access_token: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCompleteRecoveryCodeResponse
     */
    recovery_code: string;
}

/**
 * Check if a given object implements the ControlCompleteRecoveryCodeResponse interface.
 */
export function instanceOfControlCompleteRecoveryCodeResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "access_token" in value;
    isInstance = isInstance && "recovery_code" in value;

    return isInstance;
}

export function ControlCompleteRecoveryCodeResponseFromJSON(json: any): ControlCompleteRecoveryCodeResponse {
    return ControlCompleteRecoveryCodeResponseFromJSONTyped(json, false);
}

export function ControlCompleteRecoveryCodeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlCompleteRecoveryCodeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'access_token': json['access_token'],
        'recovery_code': json['recovery_code'],
    };
}

export function ControlCompleteRecoveryCodeResponseToJSON(value?: ControlCompleteRecoveryCodeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'access_token': value.access_token,
        'recovery_code': value.recovery_code,
    };
}

